// assets/quantity-bridge.js

// ✅ Hard-wire the GemPages quantity stepper buttons
window.FAQtyConfig = {
  plusSelector: 'button.gp-plus[aria-label="increment"]',
  minusSelector: 'button.gp-minus[aria-label="decrement"]',
  displaySelector: 'input[aria-label="quantity"]'
};

(function () {
  const MAX_CLICKS = 80;
  const WATCH_INTERVAL = 200;
  const IGNORE_MS = 700;

  let isSetting = false;
  let ignoreUntil = 0;

  const parseQty = (v) => {
    const n = parseInt(String(v ?? "").replace(/[^\d]/g, ""), 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  const findNamedQty = () => {
    const form =
      document.querySelector("form[action*='/cart/add']") ||
      document.querySelector("form[action^='/cart/add']") ||
      null;

    return (
      (form ? form.querySelector("input[name='quantity']") : null) ||
      document.querySelector("input[name='quantity']") ||
      null
    );
  };

  const findStepper = () => {
    const cfg = window.FAQtyConfig || {};
    if (!cfg.plusSelector || !cfg.minusSelector) return null;

    const plus = document.querySelector(cfg.plusSelector);
    const minus = document.querySelector(cfg.minusSelector);
    if (!plus || !minus) return null;

    const display = cfg.displaySelector ? document.querySelector(cfg.displaySelector) : null;
    return { plus, minus, display };
  };

  const readDisplayQty = (displayEl) => {
    if (!displayEl) return null;
    const raw = displayEl.value != null ? displayEl.value : displayEl.textContent;
    const q = parseQty(raw);
    return q >= 1 ? q : null;
  };

  const getQty = () => {
    const named = findNamedQty();
    const stepper = findStepper();

    // Prefer display if configured
    const fromDisplay = stepper?.display ? readDisplayQty(stepper.display) : null;
    if (fromDisplay != null) return fromDisplay;

    if (named && named.value != null) return parseQty(named.value);
    return 1;
  };

  const fireTagged = (el, type, source) => {
    if (!el) return;
    const evt = new Event(type, { bubbles: true });
    evt.__faSource = source;
    el.dispatchEvent(evt);
  };

  const setQty = (nextQty, { source = "unknown", silent = false } = {}) => {
    const targetQty = Math.max(1, parseInt(nextQty, 10) || 1);

    if (isSetting) return false;
    isSetting = true;
    ignoreUntil = Date.now() + IGNORE_MS;

    try {
      let changed = false;

      const named = findNamedQty();
      const stepper = findStepper();

      // Set hidden/named qty first (Shopify submission)
      if (named && parseQty(named.value) !== targetQty) {
        named.value = String(targetQty);
        fireTagged(named, "input", source);
        fireTagged(named, "change", source);
        changed = true;
      }

      // Now sync visible stepper via clicks, but stop if no progress
      if (stepper?.plus && stepper?.minus) {
        let cur = getQty();

        for (let i = 0; i < MAX_CLICKS && cur !== targetQty; i++) {
          const btn = targetQty > cur ? stepper.plus : stepper.minus;
          btn.click();

          // Re-check after click
          const after = getQty();

          // If no change, break (prevents runaway)
          if (after === cur) break;

          cur = after;
          changed = true;
        }
      }

      if (!silent && changed) {
        document.dispatchEvent(new CustomEvent("fa:quantity-updated", { detail: { qty: targetQty, source } }));
        document.dispatchEvent(new CustomEvent("fa:quantity-changed", { detail: { qty: targetQty, source } }));
      }

      return changed;
    } finally {
      isSetting = false;
    }
  };

  // Watcher emits only when we're NOT programmatically setting
  let last = null;
  (function watch() {
    if (!isSetting && Date.now() >= ignoreUntil) {
      const q = getQty();
      if (q !== last) {
        last = q;
        document.dispatchEvent(new CustomEvent("fa:quantity-changed", { detail: { qty: q, source: "watcher" } }));
      }
    }
    setTimeout(watch, WATCH_INTERVAL);
  })();

  window.FAQty = {
    getQty,
    setQty,
    findQtyInput: () => findNamedQty(),
    debugStepper: () => findStepper(),
  };
})();
